import {get} from 'lodash';

/**
 * check request data if it is an error
 * @param data
 * @returns
 */
export default function validateRequestError(data: any) {
  if (data === undefined) {
    throw new Error('Unknown error');
  }
  if ('errors' in data) {
    throw new Error(get(data, 'errors.0.message'));
  }
  return data;
}
